import { axiosApi } from 'shared/api/axios'
import { BookingEndpoint } from './constants'
import { GetBookingsResponseDTO } from '../model/dtoTypes'
import { GetBookingsRequest } from '../model'
import { adaptBookingsRequestToDTO } from '../model/adapters/adaptBookingsRequestToDTO'

export const getBookings = async (
    queries?: GetBookingsRequest,
    pagination?: { size: number; page: number },
) => {
    try {
        const params = adaptBookingsRequestToDTO(queries, pagination)

        const response = await axiosApi.get<GetBookingsResponseDTO>(
            BookingEndpoint.bookings,
            {
                params,
            },
        )

        return response.data
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка создания заказа')
    }
}
